import { useMutation } from '@tanstack/react-query';

import { ConversationRepository } from '../repositories/conversationRepository';
import { setTime } from '../utils/setTime';

import type { GetStreamOptions } from '../repositories/conversationRepository';
import type { User } from '../zustandStore/slices';

type AddMessageOptions = {
	conversationId: string;
	message: string;
	currentUser: User;
};

type GetEventsOptions = {
	conversationId: string;
	after?: string;
	polling?: boolean;
};

const eventsKeys = {
	getEvents: (options: GetEventsOptions) => ['events', options.conversationId] as const,
	getStream: (options: GetStreamOptions) => ['stream', options.after] as const,
};

export const useAddMessageMutation = () => {
	return useMutation({
		mutationFn: (options: AddMessageOptions) => ConversationRepository.addMessage(options),
	});
};

export const getEventsQuery = (options: GetEventsOptions) => ({
	queryKey: eventsKeys.getEvents(options),
	queryFn: () => ConversationRepository.getEvents(options),
	enabled: Boolean(options.conversationId),
	staleTime: setTime(1, 'hours'),
});
